angular.module('bribac.components.insuranceCompanyEditor', [
    'bribac.values',
    'bribac.translations',
    'bribac.services.api'
])
    .component('insuranceCompanyEditor', {
        bindings: {
            editableInsuranceCompany: '<',
            saveCallback: '&',
            cancelCallback: '&',
            isSubmitting: '<',
        },
        templateUrl: 'insurance-company-editor-component.html',
        controller: 'InsuranceCompanyEditorCtrl'
    })
    .controller('InsuranceCompanyEditorCtrl', function (
        $scope,
        api,
        KINDS,
        permissions,
        PHONE_NUMBER_REGEX,
        FLAVOUR,
        US_STATES
    ) {
        const $ctrl = this;
        $ctrl.flavour = FLAVOUR
        $ctrl.stateOptions = US_STATES

        $ctrl.permissions = permissions;

        $ctrl.PHONE_NUMBER_REGEX = /^\d{10,11}$|^\d{3}\s?\d{3}\s?\d{4}$/;

        $ctrl.saveInsuranceCompanyData = function () {
            const $form = $ctrl.form;

            if ($form._submitting) return;

            if ($form.$invalid) {
                $form._submitError = 'formErrors.invalidFields';
                return;
            }

            if (!($ctrl.editableInsuranceCompany.mainGroupsIds || []).length) {
                $form._submitError = 'At least one main group is required';
                return;
            }

            $form._submitSuccess = '';
            $form._submitError = '';

            $ctrl.editableInsuranceCompany.mainGroupsIds = ($ctrl.editableInsuranceCompany.mainGroupsIds || [])
                .map(group => group.id);

            $ctrl.isSubmitting = true;

            $ctrl.saveCallback({
                data: $ctrl.editableInsuranceCompany,
            }).then(() => {
                $form._submitSuccess = 'Company saved successfully';
                initializeEditableInsuranceCompany()
                $form.$setPristine();
                $form.$setUntouched();
            }).catch(error => {
                $form._submitError = 'Validation failed';
                console.error('Error while saving insurance company:', error);
            }).finally(() => {
                $ctrl.isSubmitting = false;
            });
        };


        $ctrl.cancelInsuranceCompanyForm = function () {
            $ctrl.cancelCallback();
        };

        function initializeEditableInsuranceCompany() {
            if (!$ctrl.editableInsuranceCompany) {
                $ctrl.editableInsuranceCompany = {
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                    mainGroupsIds: []
                };
            } else if (!$ctrl.editableInsuranceCompany.mainGroupsIds) {
                $ctrl.editableInsuranceCompany.mainGroupsIds = [];
            }
        }

        function reload() {
            const filter = $ctrl.organization ? `?organization=${$ctrl.organization.id}` : '';

            $ctrl.mainGroupsPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter)
                .then(function (response) {
                    $ctrl.mainGroups = response.data.list;

                    initializeEditableInsuranceCompany();

                    if (!$ctrl.editableInsuranceCompany.mainGroupsIds) {
                        $ctrl.editableInsuranceCompany.mainGroupsIds = [];
                    }

                    const availableIds = $ctrl.mainGroups.map(group => group.id);
                    $ctrl.editableInsuranceCompany.mainGroupsIds = $ctrl.editableInsuranceCompany.mainGroupsIds.filter(id => availableIds.includes(id));
                })
        }

        $scope.$watch('$ctrl.organization', function (newVal, oldVal) {
            if (newVal !== oldVal) {
                reload();
            }
        });

        $ctrl.$onInit = function () {
            initializeEditableInsuranceCompany();
            reload();
        };
    });